window.addEventListener('DOMContentLoaded', () => {
  const mainMenuLinks = [
    ...document.querySelectorAll(
      '.header__navigation > ul > li > a, .header__navigation > ul > li > span',
    ),
  ];
  const header = document.querySelector('header.header');
  const body = document.querySelector('body');
  const subMenus = [...document.querySelectorAll('.header__navigation .header__sub-navigation')];
  const mobileOpen = document.querySelector('.header__mobile-menu__open');
  const mobileClose = document.querySelector('.header__mobile-menu__close');
  const mobileSubMenuLinks = [...document.querySelectorAll('.sub-menu-deep > li > a')];
  const mobileSubMenuBackLinks = [
    ...document.querySelectorAll('.sub-menu-deep > li > ul > button'),
  ];
  const mobileNav = document.querySelector('.header__mobile-navigation > ul');
  const mobileDrawerLinks = [
    ...document.querySelectorAll('.footer__main__navigation > ul > li > .menu-item-title'),
  ];
  const mobileDrawerItems = [...document.querySelectorAll('.footer__main__navigation > ul > li a')];
  const mediaQueryTablet = matchMedia('(max-width: 1023px)');

  /**
   * Close all open dropdowns
   *
   * @return {void}
   */
  const closeAllSubMenus = () => {
    mainMenuLinks.forEach((mainMenuLink) => {
      const menuItem = mainMenuLink.closest('.menu-item');
      if (menuItem) {
        menuItem.classList.remove('menu-item--open');
      }
    });
  };

  /**
   * Open/Close mobile menu
   *
   * @param {string} openClose - 'open' or 'close'
   *
   * @return {void}
   */
  const openCloseMobileMenu = (openClose = 'open') => {
    header.classList.toggle('header--open');
    if (openClose === 'open') {
      mobileClose.focus();
    } else {
      mobileOpen.focus();
    }
  };

  /**
   * Handle tabbable drawer links
   *
   * @param {boolean} tabletSize - True if tablet size or smaller (1023px or less)
   *
   * @return {void}
   */
  const handleTabbableDrawerLinks = (tabletSize) => {
    mobileDrawerLinks.forEach((mobileDrawerLink) => {
      if (tabletSize) {
        mobileDrawerLink.setAttribute('role', 'button');
        mobileDrawerLink.setAttribute('tabindex', '0');
      } else {
        mobileDrawerLink.removeAttribute('role');
        mobileDrawerLink.removeAttribute('tabindex');
      }
    });
  };

  // Handle main menu links.
  if (mainMenuLinks.length > 0) {
    mainMenuLinks.forEach((mainMenuLink) => {
      mainMenuLink.addEventListener('keydown', (event) => {
        if (event.type === 'keydown' && event.key !== 'Enter') {
          return;
        }
        event.preventDefault();

        if (mainMenuLink.closest('.menu-item').classList.contains('menu-item--open')) {
          mainMenuLink.closest('.menu-item').classList.remove('menu-item--open');
          return;
        }

        closeAllSubMenus();
        mainMenuLink.closest('.menu-item').classList.add('menu-item--open');
      });
    });
  }

  // Close sub menu when tabbing out of the first or last focusable element.
  if (subMenus.length > 0) {
    subMenus.forEach((subMenu) => {
      const focusableElements = [...subMenu.querySelectorAll('a, button')];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      lastFocusableElement.addEventListener('keydown', (event) => {
        if (event.type === 'keydown' && event.key !== 'Tab') {
          return;
        }
        closeAllSubMenus();
      });
      mainMenuLinks.forEach((mainMenuLink) => {
        mainMenuLink.addEventListener('focus', () => {
          closeAllSubMenus();
        });
      });
    });
  }

  // Handle hitting escape key.
  body.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    const openMenu = document.querySelector(
      '.header__navigation > ul > .menu-item.menu-item--open',
    );
    if (!openMenu && !header.classList.contains('header--open')) {
      return;
    }

    // If sub menu is open, close it and move focus to parent menu item.
    if (openMenu) {
      openMenu.classList.remove('menu-item--open');
      openMenu.querySelector('a').focus();
      openMenu.querySelector('span').focus();
    }

    // Close mobile menu if open.
    if (mediaQueryTablet.matches && header.classList.contains('header--open') && mobileOpen) {
      header.classList.remove('header--open');
      mobileOpen.focus();
    }
  });

  // Handle mobile menu toggles.
  mobileOpen.addEventListener('keydown', (event) => {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return;
    }
    event.preventDefault();
    openCloseMobileMenu('open');
  });

  mobileClose.addEventListener('keydown', (event) => {
    if (event.type === 'keydown' && event.key !== 'Enter') {
      return;
    }
    event.preventDefault();
    openCloseMobileMenu('close');
  });

  // Handle mobile deep sub menu links.
  mobileSubMenuLinks.forEach((mobileSubMenuLink) => {
    mobileSubMenuLink.addEventListener('keydown', (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter') {
        return;
      }
      event.preventDefault();
      mobileNav.classList.toggle('sub-menu-deep--open');
      mobileSubMenuLink.closest('.menu-item').classList.toggle('menu-item--open');
      mobileSubMenuLink.closest('.menu-item').querySelector('ul button').focus();
    });
  });

  // Handle mobile deep sub menu back links.
  mobileSubMenuBackLinks.forEach((mobileSubMenuBackLink) => {
    mobileSubMenuBackLink.addEventListener('keydown', (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter') {
        return;
      }
      event.preventDefault();
      mobileNav.classList.toggle('sub-menu-deep--open');
      mobileSubMenuBackLink.closest('.menu-item').classList.toggle('menu-item--open');
      mobileSubMenuBackLink.closest('.menu-item').querySelector('a').focus();
    });
  });

  // Handle mobile footer drawer links.
  mobileDrawerLinks.forEach((mobileDrawerLink) => {
    mobileDrawerLink.addEventListener('keydown', (event) => {
      if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== 'Escape') {
        return;
      }
      if (event.key === 'Escape') {
        mobileDrawerLink.closest('.menu-item').classList.remove('menu-item--open');
        return;
      }
      event.preventDefault();
      mobileDrawerLink.closest('.menu-item').classList.toggle('menu-item--open');
    });
  });

  // Convert footer drawer links to buttons on mobile.
  mediaQueryTablet.addEventListener('change', (event) => {
    handleTabbableDrawerLinks(event.matches);
  });
  handleTabbableDrawerLinks(mediaQueryTablet.matches);

  // Handle closing drawers with escape key.
  mobileDrawerItems.forEach((mobileDrawerItem) => {
    mobileDrawerItem.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }
      mobileDrawerItem.closest('.menu-item--open').querySelector('.menu-item-title').focus();
      mobileDrawerItem.closest('.menu-item--open').classList.remove('menu-item--open');
    });
  });

  // Handle any reduced motion preferences.
  const motionQuery = matchMedia('(prefers-reduced-motion)');
  if (motionQuery.matches) {
    const videos = [...document.querySelectorAll('video')];
    videos.forEach((video) => {
      video.removeAttribute('autoplay');
    });
  }
});
